import { render, staticRenderFns } from "./DatabaseOpportunities.vue?vue&type=template&id=3c6a311a&scoped=true&"
import script from "./DatabaseOpportunities.vue?vue&type=script&lang=js&"
export * from "./DatabaseOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseOpportunities.vue?vue&type=style&index=0&id=3c6a311a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6a311a",
  null
  
)

export default component.exports